// Define image paths for Vite to process
const jmeFitPurple = '/JME_fit_purple.png';
const jmeFitBlackPurple = '/JME_fit_black_purple.png';
const jmeFitPhoto = '/JMEFIT_photo.png';
const img3184 = '/IMG_3184.PNG';
const img3185 = '/IMG_3185.PNG';
const img3186 = '/IMG_3186.PNG';
const img3187 = '/IMG_3187.PNG';
const img3188 = '/IMG_3188.PNG';
const img3189 = '/IMG_3189.PNG';
const img3190 = '/IMG_3190.PNG';

// Export all images
export const Images = {
  jmeFitPurple,
  jmeFitBlackPurple,
  jmeFitPhoto,
  img3184,
  img3185,
  img3186,
  img3187,
  img3188,
  img3189,
  img3190
};

export default Images;
